// extracted by mini-css-extract-plugin
export var circle = "_fx-1";
export var exitConfirmationModal = "_fx-5";
export var iframe = "_fx-0";
export var offline = "_fx-3";
export var online = "_fx-2";
export var workstationSelectError = "_fx-4";